import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { EditListItem } from '../listItems/EditListItem';

export const editColumnDefinition = (
  onClickHandler: (cellValues: GridRenderCellParams<any, any, any>) => void
): GridColDef => {
  return {
    field: 'edit',
    headerName: '',
    width: 60,
    hideable: false,
    editable: false,
    align: 'center',
    hideSortIcons: true,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    disableExport: true,
    renderCell: (cellValues: GridRenderCellParams<any, any, any>) => {
      return (
        <EditListItem
          onClick={() => {
            onClickHandler(cellValues);
          }}
        />
      );
    }
  };
};
